import React from 'react';
import AdsHeading from '@atlaskit/heading';
export function Heading(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    children = _ref.children;
  if (size === 'large') {
    return /*#__PURE__*/React.createElement(AdsHeading, {
      size: "xlarge"
    }, children);
  }
  if (size === 'small') {
    return /*#__PURE__*/React.createElement(AdsHeading, {
      size: "xsmall"
    }, children);
  }
  // size === 'medium'
  return /*#__PURE__*/React.createElement(AdsHeading, {
    size: "medium"
  }, children);
}
export default Heading;
export function HeadingFn(_ref2) {
  var Components = _ref2.Components,
    props = _ref2.props,
    children = _ref2.children,
    renderChildren = _ref2.renderChildren,
    dispatch = _ref2.dispatch,
    render = _ref2.render;
  var _ref3 = props,
    size = _ref3.size;
  return /*#__PURE__*/React.createElement(Heading, {
    size: size
  }, renderChildren({
    Components: Components,
    children: children,
    render: render,
    dispatch: dispatch
  }));
}